"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toText(editorState) {
    return editorState
        .list
        .value
        .filter(ch => 'char' in ch || ch.type !== 'block-end')
        .map(ch => {
        if ('char' in ch) {
            return ch.char;
        }
        else {
            return '\n';
        }
    }).join('');
}
exports.default = toText;
//# sourceMappingURL=toText.js.map